export const COMPANY_NAME = 'OUR PLACE OF JEFFERSON COUNTY';
export const COMPANY_SHORT = 'Our Place of Jefferson County';
export const COMPANY_MONOGRAM = 'OPJC';
export const COMPANY_ADDRESS_FULL = '568 LONGVUE DR, WINTERSVILLE, OH 43953-7307';
export const COMPANY_LOCATION = 'Wintersville, Ohio';
export const COMPANY_REGION = 'Jefferson County, Ohio';
export const MAP_URL =
  'https://www.google.com/maps/search/?api=1&query=568%20LONGVUE%20DR%2C%20WINTERSVILLE%2C%20OH%2043953-7307';

export const PROFILE_FACTS = [
  { label: 'Role', value: 'Community-based supporting organization' },
  { label: 'Region', value: COMPANY_REGION },
  { label: 'Locale', value: COMPANY_LOCATION },
  { label: 'Profile', value: 'Public directory reference' },
];

export const PUBLIC_INFO = [
  { label: 'Organization', value: COMPANY_NAME },
  { label: 'City / State', value: COMPANY_LOCATION },
  { label: 'Address', value: COMPANY_ADDRESS_FULL },
];

export const MISSION_BENTO = [
  {
    span: 'lg:col-span-3 lg:row-span-2',
    eyebrow: 'About',
    title: 'A neighborly profile for Jefferson County',
    body:
      'Our Place keeps its public identity simple: a community-based presence in Wintersville, registered to the address shown below. The page is restrained on purpose — only directory-safe information appears here.',
    tone: 'forest',
  },
  {
    span: 'lg:col-span-3',
    eyebrow: 'Region',
    title: 'Jefferson County, Ohio',
    body: 'Located in the eastern Ohio River corridor, near Wintersville and Steubenville.',
    tone: 'sand',
  },
  {
    span: 'lg:col-span-2',
    eyebrow: 'Focus',
    title: 'Community',
    body: 'A neighborhood-scale presence — no fundraising claims on this page.',
    tone: 'clay',
  },
  {
    span: 'lg:col-span-2',
    eyebrow: 'Profile',
    title: 'Public-safe',
    body: 'Registry, tax, and internal identifiers are intentionally omitted.',
    tone: 'cream',
  },
  {
    span: 'lg:col-span-2',
    eyebrow: 'Contact',
    title: 'By mail',
    body: 'Correspondence goes to the address printed on the location card.',
    tone: 'sand',
  },
];

export const FOCUS_ROWS = [
  {
    number: '01',
    title: 'Local Presence',
    body:
      'Our Place is presented as a Jefferson County neighborhood organization. The page reflects that scale — calm, plain, and rooted in the county directory.',
  },
  {
    number: '02',
    title: 'Public-Safe Information Only',
    body:
      'The profile keeps the supplied address visible while private registry and tax identifiers are kept off the client page.',
  },
  {
    number: '03',
    title: 'Editorial Tone',
    body:
      'The layout borrows from small-town civic notices: warm cream paper, hand-set serif headings, and a generous use of whitespace instead of dense marketing copy.',
  },
  {
    number: '04',
    title: 'Directory Reference',
    body:
      'Use this page as a quiet public reference for the organization name and Wintersville mailing address.',
  },
];
